import { useEffect, useState } from "react";

const useNotificationPermission = (): NotificationPermission => {
  const [permission, setPermission] = useState<NotificationPermission>(
    typeof Notification !== "undefined" ? Notification.permission : "default",
  );

  useEffect(() => {
    if (!("Notification" in window)) {
      console.warn("This browser does not support notifications.");
      setPermission("denied"); // Treat unsupported as denied
      return;
    }

    if (Notification.permission === "default") {
      Notification.requestPermission().then((perm) => {
        setPermission(perm);
      });
    } else {
      setPermission(Notification.permission);
    }
  }, []);

  return permission;
};

export default useNotificationPermission;
